import { colors, mixin } from "@hubrise/react-components"
import styled from "styled-components"

import DropdownMenu from "shared/components/DropdownMenu"
import { clickableRoundIcon } from "shared/styles/common"

import { rowHeight, stickyCell, topMargin, zIndexHeader } from "../styles"

export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  margin-top: ${`calc(${topMargin}px - 1px)`};
  z-index: ${zIndexHeader};
`

export const HeaderRow = styled.div<{ position: number }>`
  display: flex;
  position: absolute;
  top: ${({ position }) => `${position * rowHeight}px`};
  left: 0;
`

export const Text = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  ${mixin.noWrapEllipsis};
`

export const SortIcons = styled.div`
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem; // to prevent jumping when cycling between sorting states
`

export const StyledDropdownMenu = styled(DropdownMenu)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 2px;
  ${mixin.centerElement};
`

export const IconLink = styled.div`
  ${clickableRoundIcon};
`

export const Resizer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 5px;
  background: rgba(0, 0, 0, 0.5);
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  opacity: 0;
`

export const HeaderCell = styled.div<{
  center?: boolean
  width: number
  stickyPosition?: number
  isLastSticky?: boolean
  sortable: boolean
}>`
  position: relative;
  height: ${rowHeight}px;
  width: ${({ width }) => width}px;
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  outline: thin solid ${colors.borderLight};

  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: ${({ center }) => (center === true ? "center" : "flex-start")};

  background-color: ${colors.backgroundLightest};
  ${mixin.clickable};

  cursor: ${({ sortable }) => (sortable ? "pointer" : "auto")};

  ${({ stickyPosition, isLastSticky }) => stickyCell(stickyPosition, isLastSticky)};
`
